module.exports = __webpack_public_path__ + "media/images/3-highlighted-52814f157f74e279c5dff308b8b24bc6.png";